export default __webpack_public_path__ + "static/media/benefit_1.7c93dc34.png";